import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Skeleton from "react-loading-skeleton";

import GlobeIcon from "../static/icons/globe.png";
import { setCurrentProgram } from "../store/features/globalSlice";
import { Globe } from "react-feather";
import { AppColors } from "../consts/colors";

const AppProgramSelect = () => {
  const dispatch = useDispatch();
  const countryList = useSelector((state) => state.global.countryList);
  const currentProgram = useSelector((state) => state.global.currentProgram);

  useEffect(() => {
    dispatch(setCurrentProgram(countryList?.programs[0]?.programHashId));
  }, []);

  // set program object as current program on selecting program
  const handleProgramSelect = (e) => {
    dispatch(setCurrentProgram(e.target.value));
  };

  if (!currentProgram || !countryList?.programs) {
    return <Skeleton width={200} className="mx-3" height={28} />;
  }
  return (
    <>
      <div className="input-group ms-3" style={{ width: "250px" }}>
        <label className="input-group-text" htmlFor="program">
          <Globe size={14} color={AppColors.grey3} />
        </label>
        <select
          className="form-select"
          id="program"
          onChange={(e) => handleProgramSelect(e)}
          value={currentProgram}
        >
          {countryList.programs.map((item) => {
            return <Option key={item.programHashId} item={item} />;
          })}
        </select>
      </div>
    </>
  );
};

const Option = ({ item }) => (
  <option value={item.programHashId}>{item.country}</option>
);

export default AppProgramSelect;
